"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _common = require("../../../utils/common");

var _common2 = _interopRequireDefault(_common);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userInvoicesController = function () {
  function userInvoicesController(UsersService, AppContextService, NotificationService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, userInvoicesController);
    this.usersService = UsersService;
    this.appContextService = AppContextService;
    this.notificationService = NotificationService;
  }

  (0, _createClass3.default)(userInvoicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var paidInvoices = this.user.invoices.filter(function (i) {
        return i.paid;
      });
      var ctr = this;
      this.gridOptions = {
        dataSource: paidInvoices,
        sortable: true,
        pageable: false,
        resizable: true,
        noRecords: {
          template: "No Invoices."
        },
        columns: [{ field: "date", title: "Date", filterable: false, width: "4rem", template: "#= kendo.toString(new Date(date), 'dd-MM-yyyy') #" }, { field: "description", title: "Description", filterable: false, width: "8rem" },
        // { field: "subtotal", title: "Subtotal", filterable: false, width: "4rem", template: `#= '$' + (subtotal/100).toFixed(2) #` },
        // { field: "taxPercent", title: "Tax Percent", filterable: false, width: "4rem" },
        // { field: "tax", title: "Tax", filterable: false, width: "4rem", template: `#= '$' + (tax/100).toFixed(2) #` },
        // { field: "total", title: "Total", filterable: false, width: "4rem", template: `#= '$' + ((adjustedTotal - amountRefunded)/100).toFixed(2) #` },
        { field: "total", title: "Total", filterable: false, width: "4rem", template: "#= '$' + ((adjustedTotal)/100).toFixed(2) #" }, { field: "refunded", title: "Refunded", filterable: false, width: "4rem", template: "#= '$' + ((amountRefunded)/100).toFixed(2) #" }]
      };

      if (this.hasPaymentsAdminAccess()) {
        this.gridOptions.columns.push({
          title: "Refund",
          command: [{
            click: function click(e) {
              ctr.refundInvoice(this, e, ctr);
            },
            // Doesn't work with the current Kendo release.
            visible: function visible(dataItem) {
              return false;
            },
            text: "Refund"
          }],
          width: "4rem"
        });
      }
    }
  }, {
    key: "hasPaymentsAdminAccess",
    value: function hasPaymentsAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasPaymentsAdminAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "hasGlobalAdminAccess",
    value: function hasGlobalAdminAccess() {
      var appContext = this.appContextService.getAppContext();
      if (!appContext) return false;

      if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) return true;else return false;
    }
  }, {
    key: "refundInvoice",
    value: function refundInvoice(context, args, ctrl) {
      var tr = $(args.target).closest("tr");
      var invoice = context.dataItem(tr);

      if (!this.hasGlobalAdminAccess()) {
        var rawInvoice = this.user.invoices.find(function (i) {
          return i.id == invoice.id;
        });
        var invoiceIdx = this.user.invoices.indexOf(rawInvoice);
        if (invoiceIdx != this.user.invoices.length - 1) {
          alert('Only the most recent invoice can be refunded.');
          return;
        }
      }

      if (invoice.amountRefunded > 0) {
        alert('This invoice has already been refunded.');
        return;
      }

      if (confirm('Are you sure you want to refund this invoice?')) {
        ctrl.usersService.refundInvoice(invoice.id, invoice, function (response) {
          ctrl.notificationService.success("Update Successful");
          ctrl.user = response.data;

          var dataSource = new kendo.data.DataSource({
            data: ctrl.user.invoices
          });
          var grid = $("#invoices-grid").data("kendoGrid");
          grid.setDataSource(dataSource);
        }, function (error) {
          ctrl.notificationService.error(error.data ? error.data : "Update Failed");
        });
      }
    }
  }]);
  return userInvoicesController;
}();

exports.default = userInvoicesController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-invoices/user-invoices.controller.js
 **/